import us from '../../defines';
import { keyCodes } from '../../lib/key-codes';

export const createKeyboardHandler = (uScope, viewport, annotationsService) => {
  viewport.events.on('viewport:keyup', (keyCode, event) => {
    if (!uScope.canAnnotate()) {
      return;
    }

    if (keyCode === keyCodes.deleteKey) {
      // delete selected annotation
      annotationsService.regSelectDelete();
    } else if (event.ctrlKey) {
      // All other annotation events use the "ctrl" modifier

      switch (keyCode) {
        case keyCodes.c: // copy selected annotation
          uScope.startCopyMoveRegion(event, 'copy');
          break;

        case keyCodes.v: // paste selected annotation
          if (!uScope.isRegionCopyActive()) {
            // arg... really need cursor position for this to work.....
            var e = jQuery.Event('', {pageX: us.pageX, pageY: us.pageY});
            uScope.startCopyMoveRegion(e, 'copy');
          }
          uScope.stopCopyMoveRegion(); // and place the copied region here
          break;

        case keyCodes.m: // copy selected annotation
          if (!uScope.isRegionCopyActive()) {
            uScope.startCopyMoveRegion(event, 'move');
          } else {
            uScope.stopCopyMoveRegion();
          }
          break;
      }
    }
  });
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/keyboard-handler.js